// Yandex.Metrika integration for the LK SPA.
//
// The counter id defaults to the shared OrbanVPN counter and can be overridden
// at build time via `VITE_YANDEX_METRIKA_ID`. Set it to 0 to disable analytics
// (e.g. local dev) — then nothing is loaded and no requests are sent.

const DEFAULT_COUNTER_ID = 109496874;

type YmFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    ym?: YmFn & { a?: unknown[]; l?: number };
  }
}

const COUNTER_ID = ((): number | null => {
  const raw = import.meta.env.VITE_YANDEX_METRIKA_ID as string | undefined;
  if (raw === undefined) return DEFAULT_COUNTER_ID;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
})();

let initialized = false;

export function initMetrika(): void {
  if (initialized || COUNTER_ID === null || typeof window === 'undefined') return;
  initialized = true;

  // Standard Yandex.Metrika loader.
  /* eslint-disable */
  (function (m: any, e: Document, t: string, r: string, i: string) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * (new Date() as unknown as number);
    for (let j = 0; j < e.scripts.length; j++) {
      if (e.scripts[j].src === r) return;
    }
    const k = e.createElement(t) as HTMLScriptElement;
    const a = e.getElementsByTagName(t)[0];
    k.async = true;
    k.src = r;
    a.parentNode?.insertBefore(k, a);
  })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${COUNTER_ID}`, 'ym');
  /* eslint-enable */

  window.ym?.(COUNTER_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    accurateTrackBounce: true,
    trackLinks: true,
    defer: true
  });
}

export function trackPageview(url: string): void {
  if (COUNTER_ID === null || typeof window === 'undefined') return;
  window.ym?.(COUNTER_ID, 'hit', url);
}

export function trackGoal(target: string, params?: Record<string, unknown>): void {
  if (COUNTER_ID === null || typeof window === 'undefined') return;
  window.ym?.(COUNTER_ID, 'reachGoal', target, params);
}
